import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";
import SectionSeparator from "../../Recap/SectionSeparator";
import SectionTitle from "./SectionTitle";
import QuestionBlock from "./QuestionBlock";
import { connect } from "react-redux";
import { compose } from "redux";
import { changeField } from "../../../services/manager/actions";
import { romanize } from "../../../utils/romanize";
import { Translation } from "react-i18next";

import Colors from "../../../constants/Colors";

const styles = theme => ({
  main: {
    // marginTop: 15,
    width: "90%",
    flex: 1,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    display: "flex"
  },
  paper: {
    marginTop: 15,
    position: "relative",
    overflow: "hidden",
    width: "47%",
    // flex: 1,
    // height: 80,
    borderRadius: 80,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8"
  },
  root: {
    width: "100%",
    minWidth: 150,
    height: 250,
    backgroundColor: theme.palette.background.paper
  },
  bold: {
    fontWeight: 500,
    marginBottom: 10
  },
  box: {
    width: "100%",
    borderBottom: "1px solid transparent",
    borderTop: "1px solid transparent",
    borderColor: "#E1E6E8",
    flex: 1,
    flexDirection: "row",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    transition: "box-shadow 100ms ease-in-out",
    "&:hover": {
      backgroundColor: Colors.lightGrey
    },
    cursor: "pointer"
  },
  quote: {
    width: "100%",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    color: Colors.text,
    letterSpacing: "0.0075em",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex"
  },
  sign: {
    alignItems: "center",
    MozBoxSizing: "border-box",
    boxSizing: "border-box",
    display: "inline-flex",
    height: "25px",
    justifyContent: "center",
    width: "25px",
    background: "#fff",
    border: "1px solid #b7bfc6",
    borderRadius: "50%",
    color: "#848f99",
    fill: "#848f99",
    // color: "#b7bfc6",
    transition:
      "200ms box-shadow,200ms color,200ms background,200ms fill,200ms border-color",
    margin: "0 10px 0 0",
    "&:hover": {
      backgroundColor: "#e2fffa",
      borderColor: "#25e8c8",
      color: "#25e8c8",
      fill: "#25e8c8",
      cursor: "pointer"
    }
  },
  signNumber: {},
  rightSection: {
    display: "flex",
    flex: 1
  },
  title: {
    // color: "#788593"
  },
  separator: {
    width: "100%",
    height: 1,
    backgroundColor: "black"
    // backgroundColor: "#E8F3FD"
    // backgroundColor: "#fff"
  },
  titleSeparator: {
    width: "100%",
    marginBottom: 5,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    display: "flex"
  }
});

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.props.survey.map((el, sectionIndex) => {
      el.questions.map((el, questionIndex) => {
        if (el.answer) {
          const pair = `${sectionIndex}${questionIndex}`;
          this.setState({
            [pair]: !this.state[pair]
          });
        }
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.survey !== this.props.survey) {
      this.props.survey.map((el, sectionIndex) => {
        el.questions.map((el, questionIndex) => {
          if (el.answer) {
            const pair = `${sectionIndex}${questionIndex}`;
            this.setState({
              [pair]: true
            });
          }
        });
      });
    }
  }

  onClickQuestion = (sectionNumber, questionNumber) => () => {
    console.log(sectionNumber);
    console.log(questionNumber);
    const pair = `${sectionNumber}${questionNumber}`;
    this.setState({
      [pair]: !this.state[pair]
    });
    console.log(this.state.pair);
  };

  onClickFundamentalQuestion = questionNumber => () => {
    const stateKey = `fundamentalSurvey${questionNumber}`;
    this.setState({
      [stateKey]: !this.state[stateKey]
    });
  };

  onChangeQuestionInput = (sectionIndex, questionIndex) => e => {
    const answer = e.target.value;
    const survey = [...this.props.managerSurvey.survey];
    survey[sectionIndex].questions[questionIndex].answer = answer;
    this.props.changeField({
      managerSurvey: { ...this.props.managerSurvey, survey }
    });
  };

  displaySurvey = survey => {
    return survey.map((el, sectionIndex) => {
      return (
        <div key={sectionIndex}>
          <SectionTitle
            text={`${romanize(sectionIndex + 1)}. ${el.sectionTitle}`}
          />
          {el.questions.map((el, questionIndex) => (
            <QuestionBlock
              onChangeText={this.onChangeQuestionInput(
                sectionIndex,
                questionIndex
              )}
              inputValue={
                this.props.survey[sectionIndex].questions[questionIndex].answer
              }
              isSelected={this.state[`${sectionIndex}${questionIndex}`]}
              noTopBorder={questionIndex === 0}
              number={questionIndex + 1}
              key={questionIndex}
              text={el.title}
              onClick={this.onClickQuestion(sectionIndex, questionIndex)}
            />
          ))}
        </div>
      );
    });
  };

  displaySomeQuestions = survey => {
    return survey[0].questions.map((el, questionIndex) => (
      <QuestionBlock
        onChangeText={this.onChangeQuestionInput(0, questionIndex)}
        inputValue={this.props.survey[0].questions[questionIndex].answer}
        isSelected={this.state[`${0}${questionIndex}`]}
        noTopBorder={questionIndex === 0}
        number={questionIndex + 1}
        key={questionIndex}
        text={el.title}
        onClick={this.onClickQuestion(0, questionIndex)}
      />
    ));
  };

  onChangeFundamentalQuestionInput = questionIndex => e => {
    const answer = e.target.value;
    const fundamentalSurvey = { ...this.props.managerSurvey.fundamentalSurvey };
    fundamentalSurvey.questions[questionIndex].answer = answer;
    this.props.changeField({
      managerSurvey: { ...this.props.managerSurvey, fundamentalSurvey }
    });
  };

  displayFundamentalSurvey = survey => {
    const el = survey;
    if (!el) {
      return <div></div>;
    }
    return (
      <div>
        <SectionTitle text={`${el.sectionTitle}`} />
        {el.questions.map((el, questionIndex) => (
          <QuestionBlock
            onChangeText={this.onChangeFundamentalQuestionInput(questionIndex)}
            inputValue={
              this.props.managerSurvey.fundamentalSurvey.questions[
                questionIndex
              ].answer
            }
            isSelected={this.state[`fundamentalSurvey${questionIndex}`]}
            noTopBorder={questionIndex === 0}
            number={questionIndex + 1}
            key={questionIndex}
            text={el.title}
            onClick={this.onClickFundamentalQuestion(questionIndex)}
          />
        ))}
      </div>
    );
  };

  translateSurvey = survey => {};

  render() {
    const { classes, survey, managerSurvey } = this.props;
    if (!this.props.areMoreQuestionsVisible) {
      return (
        <div className={classes.main}>
          <div>
            {/* {this.displayFundamentalSurvey(managerSurvey.fundamentalSurvey)} */}
          </div>
          <SectionTitle text="SUGGESTIONS POUR ALLER PLUS LOIN :" />
          {this.displaySomeQuestions(survey)}
        </div>
      );
    }
    return (
      <div className={classes.main}>
        <div>
          {/* {this.displayFundamentalSurvey(managerSurvey.fundamentalSurvey)} */}
        </div>
        {this.displaySurvey(survey)}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    managerSurvey: state.manager.managerSurvey,
    survey: state.manager.managerSurvey.survey
  };
};

export default connect(
  mapStateToProps,
  { changeField }
)(withStyles(styles)(Survey));
